<template>
    <div class="sample-order-fix-apply">
        <div class="bread-crumb-container">
            <div class="bread-crumb-item" @click="$router.push({name:'OrderCenter'})">订单列表</div>
            <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
            <div class="bread-crumb-item" @click="$router.push({name:'OrderDetail',query:{uuid:order_uuid}})">订单详情</div>
            <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
            <div class="bread-crumb-item active">申请售后</div>
        </div>
        <div class="apply-form-body">
            <div class="form-title">
                <div class="main-title">
                    <img src="@/assets/images/icon-sample-order-fix-service.png" alt="" class="service-icon">
                    <div class="title-text">样衣订单售后申请</div>
                </div>
                <div class="description">请详细填写售后相关信息，我们将尽快为您处理</div>
            </div>
            <div class="form-container">
                <div class="form-item">
                    <div class="item-label">售后商品：</div>
                    <div class="product-info">
                        <img :src="designData.style_img|default_img" alt="" class="product-image" />
                        <div class="info-container">
                            <div class="product-name">{{designData.style_name || '-'}}</div>
                            <div class="spec-num">{{designData.spec_info && designData.spec_info[0] ? designData.spec_info[0] : '-'}}</div>
                        </div>
                    </div>
                </div>
                <div class="form-item">
                    <div class="item-label required">售后类型：</div>
                    <div class="apply-type">
                        <div class="type-item" @click="form.type = 1">
                            <div class="item-option-name">
                                <input type="radio" name="type" value="1" v-model="form.type" />
                                <div class="opt-name">返修</div>
                            </div>
                            <div class="item-desc">对现有样衣进行局部修复处理</div>
                        </div>
                        <div class="type-item" @click="form.type = 2">
                            <div class="item-option-name">
                                <input type="radio" name="type" value="2" v-model="form.type" />
                                <div class="opt-name">换料重做</div> 
                            </div>
                            <div class="item-desc">对现有样衣进行局部修复处理</div>
                        </div>
                        <div class="type-item" @click="form.type = 3">
                            <div class="item-option-name">
                                <input type="radio" name="type" value="3" v-model="form.type" />
                                <div class="opt-name">改版重做</div>
                            </div>
                            <div class="item-desc">对现有样衣进行局部修复处理</div>
                        </div>
                    </div>
                </div>
                <div class="form-item">
                    <div class="item-label">售后描述：</div>
                    <div class="apply-desc">
                        <textarea placeholder="请输入售后描述" v-model="form.desc"></textarea> 
                        <div class="text-count">{{form.desc.length || '0'}}/500</div>
                    </div>
                </div>
                <div class="form-item">
                    <div class="item-label">图片凭证：</div>
                    <div class="apply-upload">
                        <div class="img-box" v-for="(img, idx) in form.image_list" :key="idx">
                            <img :src="img" alt="" class="main-img" v-viewer />
                            <img class="delete-ico" src="@/assets/images/icon-close-circle-transparent.png" @click="deleteImage(idx)" />
                        </div>
                        <Upload v-if="form.image_list.length < 8"
                            :action="upload_url"
                            :data="{ dir: 'template' }"
                            :before-upload="(file) => beforeUploadImage(file)"
                            :show-upload-list="false"
                            :format="['jpg','jpeg','png','gif','bmp','webp']"
                            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
                            multiple
                        >
                            <div class="upload-btn">
                                <img src="@/assets/images/icon-upload.png" alt="" class="upload-icon" />
                                <div class="btn-text">
                                    <p>上传图片</p>
                                    <p>(最多8张)</p>
                                </div>
                            </div>
                        </Upload>
                        
                    </div>
                </div>
                <div class="form-item">
                    <div class="item-label">视频凭证：</div>
                    <div class="apply-upload">
                        <Upload
                            v-if="!form.video"
                            :action="upload_url"
                            :data="{ dir: 'template' }"
                            :before-upload="(file) => beforeUploadVideo(file)"
                            :show-upload-list="false"
                            :format="['mp4','mov','avi','wmv','flv','mkv','webm']"
                            accept="video/mp4,video/quicktime,video/x-msvideo,video/x-ms-wmv,video/x-flv,video/x-matroska,video/webm"
                        >
                            <div class="upload-btn">
                                <img src="@/assets/images/icon-upload.png" alt="" class="upload-icon" />
                                <div class="btn-text">
                                    <p>上传视频</p>
                                    <p>(最多1个)</p>
                                </div>
                            </div>
                        </Upload>
                        <div class="img-box" v-if="form.video">
                            <img :src="videoCover" class="main-img" @click="onPreviewVideo(form.video)" />
                            <img class="play-ico" src="@/assets/images/icon-play.png" @click="onPreviewVideo(form.video)" />
                            <img class="delete-ico" src="@/assets/images/icon-close-circle-transparent.png" @click="deleteVideo" />
                        </div>
                    </div>
                </div>
                <div class="submit-btn" @click="submit">提交申请</div>
            </div>
            
        </div>
        <!-- 视频预览弹窗 -->
        <div v-if="show_video_preview" class="video-preview-mask" @click="closeVideoPreview">
            <div class="video-preview-container" @click.stop>
                <div class="video-preview-close" @click="closeVideoPreview">×</div>
                <video :src="preview_video_url" controls autoplay class="video-preview"></video>
            </div>
        </div>
    </div>
</template>
<script>
import { OrderDetail, SampleOrderFix } from '@/api/index';
import { uploadFileToOSS } from "@/utils/oss";
export default{
    data(){
        return{
            upload_url: process.uniEnv.BASE_API + "/util/upload-image",
            uploading: false,
            uploadQueue: [],
            debounceTimer: null,
            debounceTime: 300,
            show_video_preview: false,
            preview_video_url: '',
            form:{
                desc:'',
                image_list:[],
                video:'',
                type:'',
                order_design_id:''
            },
            order_uuid:'',
            detail:{}
        }
    },
    computed: {
        videoCover() {
            return this.form.video ? `${this.form.video}?x-oss-process=video/snapshot,t_1000,m_fast` : '';
        },
        designData(){
            const {mtms} = this.detail;
            if(!mtms) return {};
            return mtms[0];
        }
    },
    mounted(){
        const uuid = this.$route.query.uuid;
        this.order_uuid = uuid;
        this.getOrderDetail();
    },
    methods:{
        async getOrderDetail(){
            try{
                const {code,msg,data} = await OrderDetail({uuid:this.order_uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                // console.log('data',data);
                this.detail = data;
                console.log('detail',this.detail);
            }catch(err){
                console.log('err-order-detail',err);
            }
        },
        async submit(){
            try{
                console.log('this.designData',this.designData);
                this.form.order_design_id = this.designData.id;
                if(!this.form.order_design_id){
                    this.$layer.msg('参数缺失[ORDER_DESIGN_ID]');
                    return;
                }
                console.log('this.form====>',this.form);
                if(!this.form.type){
                    this.$layer.msg('请选择售后类型');
                    return;
                }
                const {code,msg} = await SampleOrderFix(this.form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('提交成功');
                this.$router.back();
            }catch(err){
                console.log('err-sample-order-fix',err);
            }
        },
        beforeUploadImage(file) {
            const allowTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
            if (!allowTypes.includes(file.type)) {
                this.$layer.msg('仅支持jpg、jpeg、png、gif、bmp、webp格式的图片');
                return false;
            }
            if (this.form.image_list.length >= 8) {
                this.$layer.msg("最多只能上传8张图片");
                return false;
            }
            this.uploading = true;
            this.uploadQueue.push(file);

            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }

            this.debounceTimer = setTimeout(() => {
                this.processImageFiles();
            }, this.debounceTime);
            return false;
        },
        async processImageFiles() {
            const queue = [...this.uploadQueue];
            this.uploadQueue = [];

            let truncated = false;
            if (queue.length + this.form.image_list.length > 8) {
                truncated = true;
            }

            const remaining = 8 - this.form.image_list.length;
            const filesToUpload = remaining > 0 ? queue.slice(0, remaining) : [];
            for (const file of filesToUpload) {
                try {
                    const url = await uploadFileToOSS(file, "template");
                    this.form.image_list.push(url);
                } catch (err) {
                    this.$layer.msg(`上传失败：${file.name}`);
                }
            }

            if (truncated) {
                this.$layer.msg("最多只能上传8张图片，超出部分已自动忽略");
            }
        },
        deleteImage(idx) {
            this.form.image_list.splice(idx, 1);
        },
        beforeUploadVideo(file) {
            const allowTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-flv', 'video/x-matroska', 'video/webm'];
            if (!allowTypes.includes(file.type)) {
                this.$layer.msg('仅支持mp4、mov、avi、wmv、flv、mkv、webm格式的视频');
                return false;
            }
            uploadFileToOSS(file, "template").then(url => {
                this.form.video = url;
            }).catch(() => {
                this.$layer.msg(`上传失败：${file.name}`);
            });
            return false;
        },
        deleteVideo() {
            this.form.video = '';
        },
        onPreviewVideo(url) {
            this.preview_video_url = url;
            this.show_video_preview = true;
        },
        closeVideoPreview() {
            this.show_video_preview = false;
            this.preview_video_url = '';
        }
    }
}
</script>
<style scoped lang="scss">
.sample-order-fix-apply{
    width:100%;
    height: 100%;
    background:#f8f9fb;
    display:flex;
    flex-direction:column;
    row-gap:19px;
    padding:20px 94px 40px 30px;
    .bread-crumb-container{
        display:flex;
        align-items:center;
        column-gap:8px;
        .bread-crumb-item{
            font-size:14px;
            color:#999;
            cursor:pointer;
            &.active,&:hover{
                color:#333;
            }
        }
    }
    .apply-form-body{
        flex:1;
        width:100%;
        background:#fff;
        .form-title{
            width:100%;
            padding:18px 40px 16px 40px;
            display:flex;
            flex-direction:column;
            row-gap:5px;
            border-bottom:1px solid #e3e3e3;
            .main-title{
                display:flex;
                align-items:center;
                column-gap:8px;
                .service-icon{
                    width:24px;
                    height:24px;
                }
                .title-text{
                    color:#0f1115;
                    font-size:18px;
                    font-weight:bold;
                }
            }
            .description{
                color:#666;
                font-size:12px;
            }
        }
        .form-container{
            width:100%;
            padding:33px 40px;
            display:flex;
            flex-direction:column;
            row-gap:32px;
            .form-item{
                display:flex;
                column-gap:12px;
                .item-label{
                    color:#333;
                    font-size:14px;
                    margin-top:12px;
                    flex-shrink:0;
                    &.required::after{
                        content:"*";
                        color:red;
                    }
                }
                .product-info{
                    display:flex;
                    column-gap:20px;
                    .product-image{
                        width:96px;
                        height:96px;
                        border:1px solid #e3e3e3;
                        border-radius:8px;
                    }
                    .info-container{
                        display:flex;
                        flex-direction:column;
                        row-gap:8px;
                        margin-top:12px;
                        .product-name{
                            color:#333;
                            font-size:16px;
                        }
                        .spec-num{
                            color:#666;
                            font-size:14px;
                        }
                    }
                }
                .apply-type{
                    display:flex;
                    column-gap:16px;
                    .type-item{
                        width:200px;
                        height:65px;
                        display:flex;
                        // align-items:center;
                        flex-direction:column;
                        border:1px solid #e3e3e3;
                        border-radius:4px;
                        cursor:pointer;
                        padding:15px 10px 12px 10px;
                        .item-option-name{
                            display:flex;
                            align-items:center;
                            column-gap:6px;
                            input[type="radio"]{
                                appearance: none;
                                width: 16px;
                                height: 16px;
                                border: 1px solid #d9d9d9;
                                border-radius: 50%;
                                background-color: #fff;
                                cursor: pointer;
                                margin: 0;
                                &:checked{
                                    border-color: #FF5967;
                                    background: radial-gradient(circle, #FF5967 4px, #fff 4px);
                                }
                            }
                            .opt-name{
                                color:#333;
                                font-size:14px;
                                font-weight:500;
                            }
                        }
                        .item-desc{
                            color:#666;
                            font-size:12px;
                        }
                    }
                }
                .apply-desc{
                    width:600px;
                    height:146px;
                    border:1px solid #e3e3e3;
                    border-radius:4px;
                    padding:12px 12px 10px 16px;
                    position:relative;
                    textarea{
                        width:100%;
                        height:100%;
                        border:none;
                        outline:none;
                        resize:none;
                        background:transparent;
                    }
                    .text-count{
                        position:absolute;
                        bottom:10px;
                        right:12px;
                        color:#b3b3b3;
                        font-size:14px;
                    }
                }
                .apply-upload{
                    width:480px;
                    display:flex;
                    flex-wrap:wrap;
                    gap:10px;
                    .upload-btn{
                        width:110px;
                        height:110px;
                        border:1px dashed #e3e3e3;
                        border-radius:4px;
                        background:#f8f9fb;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        flex-direction:column;
                        cursor:pointer;
                        .upload-icon{
                            width:24px;
                            height:24px;
                        }
                        .btn-text{
                            color:#999;
                            font-size:12px;
                        }
                    }
                    .img-box{
                        width:110px;
                        height:110px;
                        position:relative;
                        border-radius:4px;
                        overflow:hidden;
                        cursor: pointer;
                        .main-img{
                            width:100%;
                            height:100%;
                            object-fit:cover;
                            z-index:1;
                        }
                        .play-ico{
                            width:32px;
                            height:32px;
                            position:absolute;
                            top:50%;
                            left:50%;
                            transform:translate(-50%,-50%);
                            z-index:3;
                            cursor:pointer;
                        }
                        .delete-ico{
                            width:20px;
                            height:20px;
                            cursor:pointer;
                            position:absolute;
                            top:0;
                            right:0;
                            z-index:5;
                        }
                    }
                }
            }
            .submit-btn{
                width:250px;
                height:48px;
                color:#fff;
                background:#ff5967;
                text-align:center;
                line-height:48px;
                cursor:pointer;
            }
        }
        
    }
}
.video-preview-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.9);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .video-preview-container {
        position: relative;
        width: 80%;
        max-width: 900px;
        .video-preview-close {
            position: absolute;
            top: -40px;
            right: 0;
            color: #fff;
            font-size: 32px;
            cursor: pointer;
            z-index: 10;
            line-height: 1;
        }
        .video-preview {
            width: 100%;
            max-height: 80vh;
            border-radius: 8px;
            outline: none;
        }
    }
}
</style>
